import { Step, StepLabel, Stepper } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

import { api_gateway } from '../../../conexoes/api'
import { revelarRealocacao } from '../../../redux/actions/index'
import {
  alertaAtencao,
  elipseVerde,
  fecharJanela,
  lixeiraVermelho,
  setaDropdown
} from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import { formatarData } from '../../../utils/formatadorDataTabela'
import { identificarValidacaoAcoes } from '../../../utils/identificarValidacaoAcoes'
import PaginacaoTabela from '../../../utils/paginacaoTabela'
import {
  AvisoCampoObrigatorio,
  iconeAlerta,
  RenderInputRows
} from '../../adicionarSimcards/RenderInputs'
import ColetaClickstream from '../../clickstreamAnalise/clickstreamColeta.js'
import MensagemAtencao from '../../componentesModais/mensagens/mensagemAtencao'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import SelectFormaEnvio from '../../componentesModais/selects/selectFormaEnvio'
import SelectMotivoReposicao from '../../componentesModais/selects/selectMotivoReposicao'
import SelectTipoEndereco from '../../componentesModais/selects/selectTipoEndereco'
import SelectUf from '../../componentesModais/selects/selectUf2'
import BotoesDadosEnvio from '../../dadosDeEnvio/BotoesDadosEnvio'
import Divider from '../../Mantine/Divider/index.jsx'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'

import AlertPlan from './Alerta/plan.jsx'

import '../../../css/painelDispositivos/dspCancelamentoReposicao/reposicao.css'

const moment = require('moment')

const valorLimite = 50
let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
let simcardSelecionados = []
let itensVar = []

const routeM1FiltrarSimcard = '/m1/filtrar/simcard'

const stepsStyle = {
  '& .Mui-active': {
    '& .MuiStepIcon-root': {
      color: '#33CC99',
      fontSize: '1.5rem !important'
    }
  },
  '& .Mui-completed': {
    '& .MuiStepIcon-root': {
      color: '#33CC99',
      fontSize: '1.5rem !important'
    }
  },
  '& .Mui-disabled': {
    '& .MuiStepIcon-root': {
      fontSize: '1.5rem !important'
    }
  }
}

const stepLabelStyleEscuro = {
  '& .MuiStepLabel-label': {
    color: '#FFF !important',
    '& .Mui-active': {
      color: '#FFF !important'
    }
  }
}

const COLUNAS_ITENS_INVALIDOS = [
  {
    dataField: 'CALLERID',
    text: 'Linha',
    headerClasses: 'nao-selecionavel',
    formatter: (cell) => {
      return <p className="fonte-cor-1 label-tabela-nao-permitidos">{cell}</p>
    }
  },
  {
    dataField: 'ds_motivo',
    text: 'Motivo',
    headerClasses: 'nao-selecionavel',
    formatter: (cell) => {
      return <p className="fonte-cor-1 label-tabela-nao-permitidos">{cell}</p>
    }
  }
]

const STEPS = ['Linhas Selecionadas', 'Adicionar SIM Cards', 'Dados do envio']

export default function Realocacao(props) {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const { register, handleSubmit, errors } = useForm()
  const [dsMotivo, setDsMotivo] = useState('')
  const [caracteresMensagem, setCaracteresMensagem] = useState(1000)
  const [quantidadeLinhasSelecionadas, setQuantidadeLinhasSelecionadas] =
    useState(-1)
  const [linhaRemover, setLinhaRemover] = useState('')
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [simcards, setSimcards] = useState([])
  const [itens, setItens] = useState([])
  const [linhas, setLinhas] = useState([])
  const [itensInvalidos, setItensInvalidos] = useState([])
  const [revelarMensagemAtencaoInvalido, setRevelarMensagemAtencaoInvalido] =
    useState(false)
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [itensInvalidosBusca, setItensInvalidosBusca] = useState(false)
  const [dsResponsavel, setDsResponsavel] = useState('')
  const [dsFormaEnvio, setDsFormaEnvio] = useState('Selecione')
  const [revelarSelectFormaEnvio, setRevelarSelectFormaEnvio] = useState(false)
  const [cdTipoEndereco, setCdTipoEndereco] = useState(-1)
  const [dsTipoEndereco, setDsTipoEndereco] = useState('Selecione')
  const [revelarSelectTipoEndereco, setRevelarSelectTipoEndereco] =
    useState(false)
  const [dsCep, setDsCep] = useState('')
  const [dsCepValidador, setDsCepValidador] = useState(false)
  const [dsCepErroInfo, setDsCepErroInfo] = useState('')
  const [dsEndereco, setDsEndereco] = useState('')
  const [dsNumero, setDsNumero] = useState('')
  const [dsBairro, setDsBairro] = useState('')
  const [dsCidade, setDsCidade] = useState('')
  const [cdEstado, setCdEstado] = useState(-1)
  const [dsNomeFantasia, setDsNomeFantasia] = useState('')
  const [dsOutroEnvio, setDsOutroEnvio] = useState('')
  const [dsEstado, setDsEstado] = useState('Selecione')
  const [revelarSelectUf, setRevelarSelectUf] = useState(false)
  const [infoAdicionais, setInfoAdicionais] = useState('')
  const [blAdicionarEndereco, setBlAdicionarEndereco] = useState(false)
  const [somatorio, setSomatorio] = useState(0)
  const [itensArray, setItensArray] = useState([
    {
      cd_pedido: 1,
      OPERADORA: '',
      cd_dsp_operadora: '',
      PLANO: '',
      cd_dsp_plano: '',
      TAMANHO: '',
      NUMERO_SIMCARDS: ''
    }
  ])

  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemAtencaoValor, setRevelarMensagemAtencaoValor] =
    useState(false)
  const [revelarMensagemErroQuantidade, setRevelarMensagemErroQuantidade] =
    useState(false)
  const [
    revelarMensagemErroQuantidadeMenor,
    setRevelarMensagemErroQuantidadeMenor
  ] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [
    revelarMensagemLinhasIncapacitadas,
    setRevelarMensagemLinhasIncapacitadas
  ] = useState(true)
  const [revelarSelectMotivo, setRevelarSelectMotivo] = useState(false)
  const [inputRevelado, setInputRevelado] = useState('Selecione')
  const [ADE_CODCAT, setADE_CODCAT] = useState()
  const [ADE_CODCAU, setADE_CODCAU] = useState()
  const [showAlertPlan, setShowAlertPlan] = useState(false)

  const mostrarBotaoAdicionarEndereco = blAdicionarEndereco === false
  const mostrarBotacaoCancelarAdicionarEndereco = blAdicionarEndereco === true

  const despacho = useDispatch()
  const modal = useRef()
  const valor_queima = 5

  const localTema = localStorage.getItem('tema')
  const [stepActive, setStepActive] = useState(0)

  let filtros = useSelector((state) => state.filtrosState.filtros)
  let buscaArquivo = useSelector(
    (state) => state.buscaArquivoState.buscaArquivo
  )
  let modoSelecaoSimcard = useSelector(
    (state) => state.manejadorState.modoSelecaoSimcard
  )
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let separadorLinha = useSelector(
    (state) => state.manejadorState.separadorLinha
  )
  let itensTemp = []
  let itensInvalidosTemp = []

  useEffect(() => {
    const hasVivoAlertPlan = itensArray.some(
      (item) => item.cd_dsp_operadora === 2
    )
    setShowAlertPlan(hasVivoAlertPlan)
  }, [itensArray])

  function validateQueima(row) {
    let dataAtual = moment()
    let dataCompra = moment(row.DATA_COMPRA)
    let diff = dataCompra.diff(dataAtual, 'months')
    return diff > 6
  }

  const colunas = [
    {
      dataField: 'CD_SIMCARD',
      text: 'Código',
      headerClasses: 'nao-selecionavel',
      hidden: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'OPERADORA',
      text: 'Operadora',
      headerClasses: 'nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'CALLERID',
      headerClasses: 'nao-selecionavel',
      text: 'Linha',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'ICCID',
      headerClasses: 'nao-selecionavel',
      text: 'ICCID',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell}</p>
      }
    },
    {
      dataField: 'PLANO',
      headerClasses: 'nao-selecionavel',
      text: 'Plano',
      sort: true,
      formatter: (cell) => {
        return <p className="fonte-cor-1 label-tabela-1">{cell} MB</p>
      }
    },
    {
      dataField: 'VALOR_PLANO',
      headerClasses: 'nao-selecionavel',
      text: 'Valor',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            R$ {parseFloat(cell).toFixed(2).replace('.', ',')}
          </p>
        )
      }
    },
    {
      dataField: 'DATA_COMPRA',
      headerClasses: 'nao-selecionavel',
      text: 'Data da compra',
      sort: true,
      formatter: (cell) => {
        if (cell) {
          cell = cell.replace('T', ' ').split('.')
          if (cell.length > 0) {
            cell = cell[0]
          }
        }
        return formatarData(cell, true)
      }
    },
    {
      dataField: 'DATA_PRAZO_CONTRATO',
      headerClasses: 'nao-selecionavel',
      text: 'Prazo contrato',
      sort: true,
      formatter: (cell) => {
        if (cell) {
          cell = cell.replace('T', ' ').split('.')
          if (cell.length > 0) {
            cell = cell[0]
          }
        }
        return formatarData(cell, true)
      }
    },
    {
      dataField: 'FL_PRIMEIRA_REALOCACAO',
      headerClasses: 'nao-selecionavel',
      text: 'Valor queima',
      sort: true,
      formatter: (row) => {
        return validateQueima(row) ? (
          <p className="fonte-cor-3 label-tabela-2">
            R$ {parseFloat(valor_queima).toFixed(2).replace('.', ',')}
          </p>
        ) : (
          <p className="fonte-cor-2 label-tabela-2">R$ 0,00</p>
        )
      }
    },
    {
      dataField: 'acoes',
      text: '',
      sort: false,
      headerClasses: 'tabela-coluna-ultima-header nao-selecionavel',
      formatter: () => {
        return (
          <Button
            variant="danger"
            className="botoes-tabela-acoes"
            size="sm"
            onClick={() => handleMensagemAtencao(false)}
          >
            <img
              className="icone-botao-acao-tabela"
              src={lixeiraVermelho()}
              alt="remover-linha"
            />
          </Button>
        )
      }
    }
  ]

  const eventosLinhas = {
    onClick: (e, row) => {
      setLinhaRemover(row.CD_SIMCARD)
    }
  }

  function handleMensagemAtencaoValor(confirmacao) {
    if (revelarMensagemAtencaoValor === false) {
      setRevelarMensagemAtencaoValor(true)
    } else {
      setRevelarMensagemAtencaoValor(false)
      if (confirmacao === true) {
        handleSalvar()
      }
    }
  }

  function handleMensagemErroQuantidade() {
    if (revelarMensagemErroQuantidade === false) {
      setRevelarMensagemErroQuantidade(true)
    } else {
      setRevelarMensagemErroQuantidade(false)
    }
  }

  function handleMensagemErroQuantidadeMenor() {
    if (revelarMensagemErroQuantidadeMenor === false) {
      setRevelarMensagemErroQuantidadeMenor(true)
    } else {
      setRevelarMensagemErroQuantidadeMenor(false)
    }
  }

  function handleMotivo(motivo) {
    setDsMotivo(motivo)
    setCaracteresMensagem(1000 - motivo.length)
  }

  function handleLinhasSelecionadas() {
    setQuantidadeLinhasSelecionadas(itensTemp.length)
    if (itensTemp.length === 0) {
      handleCancelar()
    }
  }

  function handleLinhasSelecionadasIncapacitadas() {
    setQuantidadeLinhasSelecionadas(itensTemp.length)
    if (itensInvalidosTemp.length > 0) {
      setRevelarMensagemAtencaoInvalido(true)
    }
  }

  async function handleRemoverLinha(CD_SIMCARD) {
    ColetaClickstream(1082) // 'realocacaoRemoverLinha'
    setRevelarMensagemAtencao(false)
    if (modoSelecaoSimcard) {
      let simcardNaoSelecionados
      if (itensInvalidosBusca) {
        simcardNaoSelecionados = itensInvalidosBusca
      }
      let simcardSelecionados = simcards
      if (
        simcardNaoSelecionados === undefined ||
        simcardNaoSelecionados === null ||
        simcardNaoSelecionados === false
      ) {
        simcardNaoSelecionados = CD_SIMCARD + ','
      } else {
        simcardNaoSelecionados += CD_SIMCARD + ','
      }
      setItensInvalidosBusca(simcardNaoSelecionados)

      for (let i = contador; i < simcardSelecionados.length; i++) {
        if (simcardSelecionados[i] == CD_SIMCARD) {
          simcardSelecionados.splice(i, 1)
        }
      }

      await Promise.all(
        itensVar.map((item_itensVar, i) => {
          if (CD_SIMCARD == item_itensVar.CD_SIMCARD) {
            itensVar.splice(i, 1)
          }
        })
      )
      handlerValidarRealocacao(itensVar)
      setItens(itensVar)
      setSimcards(simcardSelecionados)
      await contarItens()
    } else {
      itensTemp = itens
      itens.forEach(function (e, index) {
        if (CD_SIMCARD == e.CD_SIMCARD) {
          itens.splice(index, 1)
        }
      })
      setItens(itensTemp)
      handleIdSimcards()
      handleLinhasSelecionadas()

      handlerValidarRealocacao(itens)
    }
  }

  async function handlerValidarRealocacao(simcards) {
    let cd_dsp_simcards = []

    if (!Array.isArray(simcards)) {
      api_gateway
        .post('/m1/consultar/solicitacao/solicitacao_validacao_reposicao', {
          simcards: cd_dsp_simcards,
          filtros: { vazio: true }
        })
        .then((response) => {
          const data = response.data

          if (data.status === 200 && data.dados.length > 0) {
            let somatorioDiff = 0

            for (let i = 0; i < data.dados.length; i++) {
              let dataAtual = moment()
              let dataCompra = moment(data.dados[i].dt_compra)
              let diff = dataCompra.diff(dataAtual, 'months')
              if (diff > -6) {
                somatorioDiff = somatorioDiff + 5
              }
            }

            setSomatorio(somatorioDiff)
          }
        })
        .catch((error) => {
          console.error('Erro na validação de reposição:', error)
        })

      return
    }

    simcards.forEach((item_simcards) => {
      if (item_simcards.CD_SIMCARD) {
        cd_dsp_simcards.push(item_simcards.CD_SIMCARD)
      }
    })

    api_gateway
      .post('/m1/consultar/solicitacao/solicitacao_validacao_reposicao', {
        simcards: cd_dsp_simcards,
        filtros: { vazio: true }
      })
      .then((response) => {
        const data = response.data

        if (data.status === 200 && data.dados.length > 0) {
          let somatorioDiff = 0

          for (let i = 0; i < data.dados.length; i++) {
            let dataAtual = moment()
            let dataCompra = moment(data.dados[i].dt_compra)
            let diff = dataCompra.diff(dataAtual, 'months')
            if (diff > -6) {
              somatorioDiff = somatorioDiff + 5
            }
          }

          setSomatorio(somatorioDiff)
        }
      })
      .catch((error) => {
        console.error('Erro na validação de reposição:', error)
      })
  }

  async function parseSimcardObject(simcards) {
    let tempData = []
    simcards.forEach((item) => {
      tempData.push({
        cd_dsp_operadora: item.OPERADORA,
        OPERADORA: item.OPERADORA,
        cd_dsp_plano: item.PLANO,
        PLANO: item.PLANO,
        NUMERO_SIMCARDS: parseInt(item.NUMERO_SIMCARDS, 10),
        TAMANHO: item.TAMANHO
      })
    })
    return tempData
  }

  async function parseSimcardObjectArr(simcards) {
    let tempData = []
    simcards?.map((item) => {
      tempData.push(
        'Operadora: ' +
          item.OPERADORA +
          ' Tamanho:' +
          item.TAMANHO +
          ' Quantidade:' +
          item.NUMERO_SIMCARDS +
          ' Novo Plano:' +
          item.PLANO
      )
    })
    return tempData
  }

  async function handleSalvar() {
    let simcardArray = await parseSimcardObject(itensArray)
    let tempSimcards = simcards
    let tempLinhas = linhas

    setSpinAtivo(true)

    if (modoSelecaoSimcard === true) {
      tempSimcards = []
      tempLinhas = []

      let consultaSimcards
      if (props.solicitacaoCliente) {
        await api_gateway.post('/m1/deletar/solicitacao', {
          cd_crm_solicitacao: props.filtros.cd_crm_solicitacoes
        })

        consultaSimcards = await api_gateway
          .post('/m1/consultar/simcard_geral_post', {
            filtros: props.filtros,
            itensInvalidosBusca: itensInvalidosBusca
          })
          .then((resposta) => resposta.data)
          .catch((erro) => {
            throw erro.stack
          })
      } else {
        const urlGet = `${routeM1FiltrarSimcard}?acao=true&buscar=${conteudoBusca}&filtros=${JSON.stringify(filtros)}&buscaArquivo=${JSON.stringify(buscaArquivo)}&separador=${separadorLinha}&contar=false&itensInvalidosBusca=${itensInvalidosBusca}`
        consultaSimcards = await api_gateway
          .get(urlGet)
          .then((resposta) => resposta.data)
          .catch((erro) => {
            throw erro
          })
      }

      if (
        consultaSimcards.dados.length > 0 &&
        consultaSimcards.status === 200
      ) {
        await Promise.all(
          consultaSimcards.dados.map((item) => {
            tempSimcards.push(item.CD_SIMCARD)
            tempLinhas.push(item.FULLCALLERID)
          })
        )
      } else {
        setSpinAtivo(false)
        setMensagemErro('Erro na solicitação')
        handleMensagemErro(false)
        return
      }
    }

    let temporario = new Date()
    let dataHora =
      temporario.toISOString().substring(0, 10) +
      ' ' +
      temporario.getHours() +
      ':' +
      temporario.getMinutes() +
      ':' +
      temporario.getSeconds()

    let simcardsParaRota = []
    let simcardsParaEmail = []
    let linhasParaRota = []
    let linhasParaEmail = []

    let linhasRestantes = quantidadeLinhasSelecionadas

    for (let i = 0; i < simcardArray.length; i++) {
      const simcard = simcardArray[i]
      const quantidade = simcard.NUMERO_SIMCARDS

      let quantidadeParaRota = Math.min(linhasRestantes, quantidade)
      linhasRestantes -= quantidadeParaRota

      simcardsParaRota.push({
        ...simcard,
        NUMERO_SIMCARDS: quantidadeParaRota
      })
      linhasParaRota.push(...tempLinhas.slice(0, quantidadeParaRota))
      tempLinhas = tempLinhas.slice(quantidadeParaRota)

      if (quantidadeParaRota < quantidade) {
        let quantidadeParaEmail = quantidade - quantidadeParaRota
        simcardsParaEmail.push({
          ...simcard,
          NUMERO_SIMCARDS: quantidadeParaEmail
        })
        linhasParaEmail.push(...tempLinhas.slice(0, quantidadeParaEmail))
        tempLinhas = tempLinhas.slice(quantidadeParaEmail)
      }
    }

    simcardsParaRota = simcardsParaRota.filter(
      (simcard) => simcard.NUMERO_SIMCARDS > 0
    )
    simcardsParaEmail = simcardsParaEmail.filter(
      (simcard) => simcard.NUMERO_SIMCARDS > 0
    )
    simcardsParaRota = await parseSimcardObjectArr(simcardsParaRota)

    try {
      await api_gateway.post('/m1/cadastrar/solicitacao', {
        fl_operadora: 0,
        simcards: tempSimcards,
        FULLCALLERID: linhasParaRota,
        cd_crm_solicitacao_tipo: 18,
        cd_crm_solicitacao_status: 1,
        ds_crm_solicitacao: dsMotivo,
        dt_inicio: dataHora,
        dt_fim: undefined,
        dt_previsao: undefined,
        cd_pav_usuario_created: props.USUARIO,
        ds_responsavel: dsResponsavel,
        ds_formaEnvio: dsFormaEnvio == 'Outro' ? dsOutroEnvio : dsFormaEnvio,
        ds_endereco: `${dsEndereco} ${dsNumero} ${dsBairro} ${dsCidade} ${dsEstado} ${dsCep}`,
        n0_valor_realocacao: somatorio,
        valor_queima: valor_queima,
        ds_operadora_tamanho: simcardsParaRota,
        // quantidade_simcards: dsQuantidade,
        ADE_CODCAT: ADE_CODCAT,
        ADE_CODCAU: ADE_CODCAU,
        ds_rota_permissao: 'veye/dispositivos/acoes/realocacao'
      })
      handleMensagemSucesso(false)
    } catch (error) {
      setMensagemErro('Erro na solicitação')
      handleMensagemErro(false)
    } finally {
      setSpinAtivo(false)
    }

    if (simcardsParaEmail.length > 0) {
      try {
        await api_gateway.post('/m1/cadastrar/pedido_cliente', {
          ds_nome: dsResponsavel,
          ds_endereco: dsEndereco,
          ds_complemento: infoAdicionais,
          ds_bairro: dsBairro,
          ds_cidade: dsCidade,
          ds_pav_uf: dsEstado,
          ds_cep: dsCep,
          ds_numero: dsNumero,
          ds_forma_envio: dsFormaEnvio == 'Outro' ? dsOutroEnvio : dsFormaEnvio,
          dt_data_hora: moment().format('YYYY-MM-DD hh:mm:ss'),
          simcardLista: simcardsParaEmail,
          cd_dsp_cliente_endereco_entrega: cdTipoEndereco
        })
      } catch (error) {
        console.error('Erro ao enviar as linhas por e-mail:', error)
      }
    }
  }

  async function handleCancelar() {
    ColetaClickstream(1083) // 'realocacaoCancelar'
    contador = 0
    controladorPagina = 1
    totalPaginas = 0
    totalItens = 0
    itensVar = []
    itensInvalidosTemp = []
    simcardSelecionados = []
    setSpinAtivo(false)
    setRevelarMensagemLinhasIncapacitadas(true)
    despacho(revelarRealocacao(false))
  }

  function inserirData(data) {
    if (itensVar.length == totalItens) {
      for (let i = 0; i < totalItens; i++) {
        if (contador === i) {
          let k = i
          for (let j = 0; j < data.length; j++) {
            itensVar[k] = data[j]
            k++
          }
        }
        if (i == totalItens - 1) {
          itensTemp = JSON.parse(JSON.stringify(itensVar))
          setItens(JSON.parse(JSON.stringify(itensVar)))
          handleIdSimcards()
        }
      }
      handleLinhasSelecionadas()
    }
  }

  function handleIdSimcards() {
    let tempSimcards = []
    let tempLinhas = []
    for (let i = 0; i < itensTemp.length; i++) {
      tempSimcards.push(itensTemp[i].CD_SIMCARD)
      tempLinhas.push(itensTemp[i].FULLCALLERID)
    }
    simcardSelecionados = tempSimcards
    setLinhas(tempLinhas)
    setSimcards(tempSimcards)
  }

  async function handlerConsultarSimcadsBusca() {
    if (totalPaginas == 0) {
      contador = 0
      itensVar = []
      setItens([])
      await contarItens()
    } else {
      contador = (paginaAtual - 1) * valorLimite
    }
    if (controladorPagina <= paginaAtual) {
      setSpinAtivo(true)
      let consultaSimcards
      if (props.solicitacaoCliente) {
        consultaSimcards = await api_gateway
          .post('/m1/consultar/simcard_geral_post', {
            carregarLimit: valorLimite,
            paguinaAtual: contador,
            filtros: props.filtros,
            itensInvalidosBusca: itensInvalidosBusca
          })
          .then(function (resposta) {
            return resposta.data.dados
          })
          .catch(function (erro) {
            throw erro.stack
          })
      } else {
        const urlGet = `${routeM1FiltrarSimcard}?paguinaAtual=${contador}&carregarLimit=${valorLimite}&acao=true&buscar=${conteudoBusca}&filtros=${JSON.stringify(filtros)}&buscaArquivo=${JSON.stringify(buscaArquivo)}&separador=${separadorLinha}&contar=false&itensInvalidosBusca=${itensInvalidosBusca}`
        consultaSimcards = await api_gateway
          .get(urlGet)
          .then(function (resposta) {
            return resposta.data.dados
          })
          .catch(function (erro) {
            throw erro
          })
      }
      setSpinAtivo(false)
      inserirData(consultaSimcards)
    }
  }

  useEffect(() => {
    if (modoSelecaoSimcard && itensInvalidosBusca) {
      handlerConsultarSimcadsBusca()
    }
  }, [itensInvalidosBusca, paginaAtual])

  useEffect(() => {
    let validacao = []

    async function preencherTabela() {
      setSpinAtivo(true)
      if (props.solicitacaoCliente) {
        //! esse codigo é usado na painelVirtueyes\solicitacaoCliente\tabela.js, na tela veye/virtueyes/clientes acao reenviar - trocar ocorrencia
        //! mas esta quebrando, marcelly vai confirmar se é usado com o time da virtueyes

        handlerConsultarSimcadsBusca()
        setItensInvalidosBusca([])
        handlerValidarRealocacao(false)
      } else {
        validacao = await identificarValidacaoAcoes(
          props.itensSelecionados,
          18,
          { filtros, buscaArquivo },
          modoSelecaoSimcard,
          conteudoBusca,
          separadorLinha
        )

        handlerValidarRealocacao(validacao.itensValidos)
        if (modoSelecaoSimcard) {
          itensTemp = validacao.itensValidos
          itensInvalidosTemp = validacao.itensInvalidos
          setItensInvalidos(validacao.itensInvalidos)
          if (itensInvalidosTemp.length > 0) {
            await Promise.all(
              validacao.itensInvalidos.map((item_validacao) => {
                simcardSelecionados += item_validacao.CD_SIMCARD + ','
              })
            )
            setItensInvalidosBusca(simcardSelecionados)
            setSimcards(validacao.itensValidos)
            handleIdSimcards()
          } else {
            handlerConsultarSimcadsBusca()
          }
        } else {
          setItens(validacao.itensValidos)
          setItensInvalidos(validacao.itensInvalidos)
          setQuantidadeLinhasSelecionadas(validacao.itensValidos.length)
          itensTemp = validacao.itensValidos
          itensInvalidosTemp = validacao.itensInvalidos
          handleIdSimcards()
          setItensInvalidosBusca(true)
        }
      }

      if (
        revelarMensagemLinhasIncapacitadas == true &&
        validacao.itensInvalidos.length > 0
      ) {
        handleLinhasSelecionadasIncapacitadas()
        setRevelarMensagemLinhasIncapacitadas(false)
      }
      setSpinAtivo(false)
    }
    preencherTabela()
  }, [])

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual) {
      if (props.solicitacaoCliente) {
        apiData = await api_gateway.post('/m1/consultar/simcard_geral_post', {
          contar: true,
          filtros: props.filtros,
          itensInvalidosBusca: itensInvalidosBusca
        })
      } else {
        const urlGet = `${routeM1FiltrarSimcard}?acao=true&buscar=${conteudoBusca}&filtros=${JSON.stringify(filtros)}&buscaArquivo=${JSON.stringify(buscaArquivo)}&separador=${separadorLinha}&contar=true&itensInvalidosBusca=${itensInvalidosBusca}`
        apiData = await api_gateway
          .get(urlGet)
          .then(function (resposta) {
            return resposta
          })
          .catch(function (erro) {
            throw erro
          })
      }
    }

    totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
    totalItens = apiData.data.dados[0].CONTADOR
    for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
      arrayItens.push(i)
    }
    itensVar = arrayItens
  }

  const opcoesPaginacao = {
    page: paginaAtual,
    showTotal: true,
    sizePerPage: valorLimite,
    firstPageTitle: 'Primeira',
    lastPageTitle: 'Última',
    nextPageTitle: 'Proxima',
    prePageTitle: 'Anterior',
    custom: true,
    onPageChange: (page) => {
      setPaginaAtual(page)
    }
  }

  function handleMensagemAtencao(confirmacao) {
    if (revelarMensagemAtencao === false) {
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
    }
    if (confirmacao === true) {
      handleRemoverLinha(linhaRemover)
    }
  }

  async function handleAdicionarEndereco() {
    let resposta = false

    if (
      dsEndereco === '' ||
      dsNumero === '' ||
      dsCep === '' ||
      dsBairro === '' ||
      dsCidade === '' ||
      dsEstado === 'Selecione'
    ) {
      setMensagemErro('Preencha todos os campos obrigatórios')
      setRevelarMensagemErro(true)
      return false
    }

    setSpinAtivo(true)
    if (props.solicitacaoCliente) {
      await api_gateway
        .post('/m1/cadastrar/cliente_endereco_entrega', {
          ds_nome: dsTipoEndereco,
          cd_pav_cliente: props.cd_pav_cliente,
          ds_numero: dsNumero,
          ds_endereco: dsEndereco,
          ds_cep: dsCep,
          cd_pav_uf: cdEstado,
          ds_complemento: infoAdicionais,
          ds_bairro: dsBairro,
          ds_cidade: dsCidade,
          fl_considerar_busca: 1
        })
        .then(function (response) {
          if (response.data.status == 200) {
            setCdTipoEndereco(response.data.dados.idInserido)
            resposta = true
          }
        })
        .catch(function (error) {
          setMensagemErro(error.response.data.info)
        })
        .finally(() => {
          setSpinAtivo(false)
        })
    } else {
      await api_gateway
        .post('/m1/cadastrar/cliente_endereco_entrega', {
          ds_nome: dsTipoEndereco,
          cd_pav_cliente: decryptJWT('codigoCliente'),
          ds_numero: dsNumero,
          ds_endereco: dsEndereco,
          ds_cep: dsCep,
          cd_pav_uf: cdEstado,
          ds_complemento: infoAdicionais,
          ds_bairro: dsBairro,
          ds_cidade: dsCidade,
          fl_considerar_busca: 1
        })
        .then(function (response) {
          if (response.data.status == 200) {
            setCdTipoEndereco(response.data.dados.idInserido)
            resposta = true
          }
        })
        .catch(function (error) {
          setMensagemErro(error.response.data.info)
        })
        .finally(() => {
          setSpinAtivo(false)
        })
    }
    setBlAdicionarEndereco(false)
    return resposta
  }

  function handleBlAdicionarEndereco(bl) {
    setDsTipoEndereco('')
    setDsCep('')
    setDsEndereco('')
    setDsNumero('')
    setDsBairro('')
    setDsCidade('')
    setDsEstado('Selecione')
    setInfoAdicionais('')
    setBlAdicionarEndereco(bl)

    if (!bl) {
      setDsTipoEndereco('Selecione')
      setCdTipoEndereco(-1)
      setDsNomeFantasia('')
    }
  }

  async function handlerConsultarCep(cep) {
    await api_gateway
      .get('/m1/consultar/cep?cep=' + cep)
      .then(function (response) {
        if (response.data.status == 200) {
          if (response.data.dados == 'Cep Invalido') {
            setDsCepValidador(true)
            setDsCepErroInfo(response.data.dados)
            setDsBairro('')
            setDsCidade('')
            setDsEstado('Selecione')
            setCdEstado(-1)
            setDsEndereco('')
          } else {
            setDsCepValidador(false)
            setDsCep(response.data.dados.cep)
            setDsBairro(response.data.dados.bairro)
            setDsCidade(response.data.dados.localidade)
            setDsEstado(response.data.dados.uf)
            setCdEstado(response.data.dados.cd_pav_uf)
            setDsEndereco(response.data.dados.logradouro)
          }
        }
        return response
      })
      .catch(function (error) {
        if (error == 'Error: Request failed with status code 400') {
          setDsCepValidador(true)
          setDsCepErroInfo('Cep Invalido')
        } else {
          setDsCepValidador(true)
          setDsCepErroInfo('Erro interno')
        }
        return error
      })
  }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      handleCancelar()
    }
    if (confirmacao) {
      props.setRenderizar(!props.renderizar)
    }
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function handleFecharMensagemItensInvalidos() {
    setRevelarMensagemAtencaoInvalido(!revelarMensagemAtencaoInvalido)
    if (modoSelecaoSimcard) {
      if (itens <= 0) {
        handleCancelar()
      }
    } else {
      if (quantidadeLinhasSelecionadas <= 0) {
        handleCancelar()
      }
    }
  }

  function parsePedidosAdicionados() {
    let loteFinalizados = itensArray.filter(
      (item) =>
        item.OPERADORA && item.PLANO && item.TAMANHO && item.NUMERO_SIMCARDS > 0
    )
    return loteFinalizados
  }

  function parseTotalLinhas() {
    let loteFinalizados = parsePedidosAdicionados()
    let totalLinhas = loteFinalizados.reduce(
      (acc, item) => acc + parseInt(item.NUMERO_SIMCARDS),
      0
    )
    return totalLinhas
  }

  async function handleNextStep() {
    if (stepActive === 0) {
      if (dsMotivo === 'Selecione' || dsMotivo === '') {
        setMensagemErro('O campo motivo é obrigatório')
        setRevelarMensagemErro(true)
        return
      }
    }

    if (stepActive === 1) {
      let loteFinalizados = parsePedidosAdicionados()
      if (loteFinalizados.length === 0) {
        setMensagemErro(
          'Um ou mais campos do pedido estão vazios, preencha-os para prosseguir'
        )
        setRevelarMensagemErro(true)
        return
      } else if (loteFinalizados.length != itensArray.length) {
        setMensagemErro('Preencha todos os campos do pedido para prosseguir')
        setRevelarMensagemErro(true)
        return
      } else if (parseTotalLinhas() < quantidadeLinhasSelecionadas) {
        setMensagemErro(
          `Você precisa adicionar ${quantidadeLinhasSelecionadas - parseTotalLinhas()} simcards para prosseguir`
        )
        setRevelarMensagemErro(true)
        return
      }
    }
    if (stepActive === 2) {
      if (dsResponsavel === '') {
        setMensagemErro('O campo responsável é obrigatório')
        setRevelarMensagemErro(true)
        return
      }
      if (dsFormaEnvio === '') {
        setMensagemErro('O campo forma de envio é obrigatório')
        setRevelarMensagemErro(true)
        return
      }
      if (dsFormaEnvio === 'Outro' && dsOutroEnvio === '') {
        setMensagemErro('O campo forma de envio é obrigatório')
        setRevelarMensagemErro(true)
        return
      }
      if (dsEndereco === '') {
        setMensagemErro('O campo endereço é obrigatório')
        setRevelarMensagemErro(true)
        return
      }
      if (dsNumero === '') {
        setMensagemErro('O campo número é obrigatório')
        setRevelarMensagemErro(true)
        return
      }
      if (dsCep === '') {
        setMensagemErro('O campo CEP é obrigatório')
        setRevelarMensagemErro(true)
        return
      }
      if (dsBairro === '') {
        setMensagemErro('O campo bairro é obrigatório')
        setRevelarMensagemErro(true)
        return
      }
      if (dsCidade === '') {
        setMensagemErro('O campo cidade é obrigatório')
        setRevelarMensagemErro(true)
        return
      }
      if (dsEstado === 'Selecione') {
        setMensagemErro('O campo estado é obrigatório')
        setRevelarMensagemErro(true)
        return
      } else {
        if (mostrarBotacaoCancelarAdicionarEndereco) {
          const cadastrouEndereco = await handleAdicionarEndereco()
          if (!cadastrouEndereco) return
        }

        handleMensagemAtencaoValor(false)
        return
      }
    }
    setStepActive(stepActive + 1)
  }

  function handlePreviousStep() {
    if (stepActive === 0) {
      handleCancelar()
    } else {
      setStepActive(stepActive - 1)
    }
  }

  return (
    <Form
      ref={modal}
      onSubmit={handleSubmit(() => handleMensagemAtencaoValor(false))}
    >
      <div className="modal-acao-cancelamento-resposicao-novo fundo-cor-6">
        {spinAtivo && (
          <div className="componente-spinner-overlay">
            <div className="componente-spinner-container">
              <SpinerVeye />
            </div>
          </div>
        )}
        <div className="modal-novo-pedido-header">
          <Form.Row>
            <Col>
              <div className="header-novo-pedido-title">
                <div className="header-title-left-block">
                  <img
                    className="icone-label-janela"
                    src={elipseVerde()}
                    alt="elipse"
                  />
                  <Form.Label>
                    <div className="fonte-cor-1 label-janela">Reposição</div>
                  </Form.Label>
                </div>
                <div>
                  <Button
                    className="botao-fechar-janela"
                    variant="danger"
                    onClick={() => handleCancelar()}
                  >
                    <img
                      className="botao-fechar-janela-icone"
                      src={fecharJanela()}
                      alt="fechar-janela"
                    />
                  </Button>
                </div>
              </div>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <Stepper activeStep={stepActive} sx={stepsStyle}>
                {STEPS.map((label) => {
                  const stepProps = {}
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel
                        sx={localTema === 'escuro' ? stepLabelStyleEscuro : {}}
                      >
                        {label}
                      </StepLabel>
                    </Step>
                  )
                })}
              </Stepper>
            </Col>
          </Form.Row>
          <div className="label-wrapper-novo-pedido">
            <div className="fonte-cor-1 label-listagem-SIMcard">
              <div>{STEPS[stepActive]}</div>
            </div>
          </div>
        </div>

        <div className="modal-novo-pedido-content">
          {stepActive === 0 && (
            <>
              <Form.Row>
                <Col>
                  <div className="container-tabela-modal-cancelamento-reposicao-texto container-tabela-modal-cancelamento-reposicao">
                    <PaginationProvider pagination={Paginador(opcoesPaginacao)}>
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <BootstrapTable
                            classes="tabela-transparente-modais"
                            condensed
                            keyField="id"
                            data={itens}
                            columns={colunas}
                            rowEvents={eventosLinhas}
                            noDataIndication={
                              !spinAtivo && 'Nenhum item encontrado'
                            }
                            bootstrap4
                            {...paginationTableProps}
                          />

                          <div className="paguinacao-tabela-modal">
                            <PaginacaoTabela
                              extrato
                              styleClass="paginacao-tabela-reposicao-grupo-btns"
                              setPaginaAtual={setPaginaAtual}
                              totalPaginas={Math.ceil(
                                itens.length / valorLimite
                              )}
                              totalItens={totalItens}
                              valorLimite={valorLimite}
                              paginaAtual={paginaAtual}
                              page={paginationProps.page}
                              onPageChange={paginationProps.onPageChange}
                            />
                          </div>
                        </>
                      )}
                    </PaginationProvider>
                  </div>
                </Col>
              </Form.Row>
              <Col>
                <span className="contador-linhas-acoes-dispositivos-margin fonte-cor-1 label-normal contador-linhas-acoes-dispositivos">
                  {quantidadeLinhasSelecionadas} linhas selecionadas
                </span>
              </Col>

              <Form.Row>
                <Col>
                  <Form.Group>
                    <Form.Label>
                      <div className="fonte-cor-1 label-campo label-campo-margin">
                        Motivo
                      </div>
                    </Form.Label>
                    {errors.motivo_cancelamento_reposicao && (
                      <p className="fonte-cor-3 label-alerta">
                        {iconeAlerta} Informe o motivo.
                      </p>
                    )}
                    {revelarSelectMotivo === false && (
                      <Button
                        className="campo-texto-cor-3 campo-select-novo-motivo"
                        onClick={() =>
                          setRevelarSelectMotivo(!revelarSelectMotivo)
                        }
                        ref={register({ required: true })}
                        onChange={(e) => handleMotivo(e.target.value)}
                      >
                        <div className="label-interno-wrapper">
                          <div className="fonte-cor-1 label-campo-novo">
                            {inputRevelado}
                          </div>

                          <img
                            className={
                              revelarSelectMotivo
                                ? 'campo-select-icone-ativado nao-selecionavel'
                                : 'campo-select-icone-desativado nao-selecionavel'
                            }
                            src={setaDropdown()}
                            alt="drop"
                          />
                        </div>
                      </Button>
                    )}
                    {revelarSelectMotivo && (
                      <SelectMotivoReposicao
                        setRevelarSelectMotivo={setRevelarSelectMotivo}
                        styleClass="campo-select-novo-motivo"
                        setInputRevelado={setInputRevelado}
                        setADE_CODCAT={setADE_CODCAT}
                        setADE_CODCAU={setADE_CODCAU}
                        handleMotivo={handleMotivo}
                        inputRevelado={inputRevelado}
                      />
                    )}
                    {inputRevelado == 'Outros' && (
                      <>
                        <div
                          className="campo-select-triangulo-margin
                                campo-select-triangulo-cor-1 campo-select-triangulo"
                        />
                        <Form.Control
                          className="campo-texto-cor-3 campo-texto-area"
                          as="textarea"
                          rows="3"
                          name="motivo_cancelamento_reposicao"
                          ref={register({ required: true })}
                          maxlength="1000"
                          placeholder="Descreva aqui o motivo"
                          onChange={(e) => handleMotivo(e.target.value)}
                        />
                        <Form.Label className="contador-carateres-restantes">
                          <div className="fonte-cor-1 label-normal">
                            {caracteresMensagem} caracteres restantes
                          </div>
                        </Form.Label>
                      </>
                    )}
                  </Form.Group>
                </Col>
              </Form.Row>
            </>
          )}

          {stepActive === 1 && (
            <>
              <div className="lote-row-novo-pedido">
                <div className="label-row-novo-pedido">
                  <div className="fonte-cor-1" style={{ flex: 0.1 }}>
                    #
                  </div>
                  <div
                    className="fonte-cor-1 label-title-novo-pedido"
                    style={{ flex: 1.5 }}
                  >
                    Operadora
                  </div>
                  <div
                    className="fonte-cor-1 label-title-novo-pedido"
                    style={{ flex: 1.5 }}
                  >
                    Plano
                  </div>
                  <div
                    className="fonte-cor-1 label-title-novo-pedido"
                    style={{ flex: 1.3 }}
                  >
                    Tamanho SIM Card
                  </div>
                  <div
                    className="fonte-cor-1 label-title-novo-pedido"
                    style={{ flex: 1.2 }}
                  >
                    Quantidade
                  </div>
                </div>

                {itensArray.length > 0 && (
                  <RenderInputRows
                    {...{
                      itens: itensArray,
                      isReposicao: true,
                      itensArray,
                      setItensArray,
                      setMensagemErro,
                      setRevelarMensagemErro,
                      mostrarBotaoNovoLote: stepActive == 1,
                      condicao: { ignorar: { cd_dsp_operadora: '72,78' } } // ARQUIA
                    }}
                  />
                )}

                <div />
              </div>
              <AlertPlan showAlertPlan={showAlertPlan} />

              <div className="container-mensagens-alerta-reposicao fonte-cor-1">
                <p>
                  *Este processo consiste em cancelar a linha atual e enviar uma
                  nova. Haverá o custo de taxa de R$5,00 por linha somente se
                  ela estiver sido adquirida a menos de 6 meses, caso contrário,
                  não pagará taxas. O prazo para conclusão desta substituição é
                  de 1 dia útil a partir da solicitação.
                </p>
                <p>*A reposição irá com o prazo de acordo com o contratado.</p>
              </div>
            </>
          )}

          {stepActive === 2 && (
            <>
              <Form.Row>
                <Col>
                  <div className="grupo-painel-pedidos-novo-simcard-1 margin-top-divider">
                    <div className="coluna-painel-pedidos-reposicao-simcard-8">
                      <Form.Group>
                        <Form.Label>
                          <div className="fonte-cor-1 label-campo label-novo-pedido-endereco">
                            Responsável
                          </div>
                        </Form.Label>
                        <Form.Control
                          name="ds_responsavel"
                          value={dsResponsavel}
                          className="campo-texto-cor-3 campo-texto-novo-2"
                          type="text"
                          placeholder="Digite o responsavel"
                          onChange={(e) => setDsResponsavel(e.target.value)}
                          ref={register({ required: true, min: 3, max: 100 })}
                          maxlength="100"
                        />
                        {dsResponsavel === '' && <AvisoCampoObrigatorio />}
                      </Form.Group>
                    </div>
                    <div className="coluna-painel-pedidos-reposicao-simcard-8">
                      <Form.Group>
                        <Form.Label>
                          <div className="fonte-cor-1 label-campo label-novo-pedido-endereco">
                            Forma de envio
                          </div>
                        </Form.Label>
                        {revelarSelectFormaEnvio === false && (
                          <Button
                            name="cdFormaEnvio"
                            className="campo-texto-cor-3 campo-select-novo-2"
                            onClick={() =>
                              setRevelarSelectFormaEnvio(
                                !revelarSelectFormaEnvio
                              )
                            }
                          >
                            <div className="fonte-cor-1 label-campo">
                              {dsFormaEnvio}
                            </div>
                            <img
                              className="campo-select-icone-desativado"
                              src={setaDropdown()}
                              alt="drop"
                            />
                          </Button>
                        )}
                        {revelarSelectFormaEnvio === true && (
                          <SelectFormaEnvio
                            setRevelarSelectFormaEnvio={
                              setRevelarSelectFormaEnvio
                            }
                            styleClass="campo-select-novo-2"
                            setDsFormaEnvio={setDsFormaEnvio}
                            dsFormaEnvio={dsFormaEnvio}
                          />
                        )}
                        {dsFormaEnvio === 'Selecione' && (
                          <AvisoCampoObrigatorio />
                        )}
                      </Form.Group>
                      <Form.Group>
                        <Form.Control
                          hidden={dsFormaEnvio != 'Outro'}
                          name="ds_outro"
                          value={dsOutroEnvio}
                          className="campo-texto-cor-3 campo-texto-novo-2"
                          type="text"
                          placeholder="Digite outra forma de envio"
                          onChange={(e) => setDsOutroEnvio(e.target.value)}
                        />
                      </Form.Group>
                    </div>
                    <div className="coluna-painel-pedidos-reposicao-simcard-8">
                      <Form.Group>
                        <Form.Label>
                          <div className="fonte-cor-1 label-campo label-novo-pedido-endereco">
                            Tipo de endereço
                          </div>
                        </Form.Label>
                        {revelarSelectTipoEndereco === false &&
                          blAdicionarEndereco === false && (
                            <Button
                              name="cdTipoEndereco"
                              className="campo-texto-cor-3 campo-select-novo-2"
                              onClick={() =>
                                setRevelarSelectTipoEndereco(
                                  !revelarSelectTipoEndereco
                                )
                              }
                            >
                              <div className="fonte-cor-1 label-campo label-campo-select-overflow">
                                {dsTipoEndereco + dsNomeFantasia}
                              </div>
                              <img
                                className="campo-select-icone-desativado"
                                src={setaDropdown()}
                                alt="drop"
                              />
                            </Button>
                          )}
                        {revelarSelectTipoEndereco === false &&
                          blAdicionarEndereco === true && (
                            <>
                              <Form.Control
                                name="ds_endereco"
                                value={dsTipoEndereco}
                                className="campo-texto-cor-3 campo-texto-novo-2"
                                type="text"
                                placeholder="Digite o nome do Endereço"
                                onChange={(e) =>
                                  setDsTipoEndereco(e.target.value)
                                }
                                ref={register({
                                  required: true,
                                  minLength: 3,
                                  maxLength: 100
                                })}
                              />
                              {errors.ds_endereco && <AvisoCampoObrigatorio />}
                            </>
                          )}
                        {revelarSelectTipoEndereco === true && (
                          <SelectTipoEndereco
                            setRevelarSelectTipoEndereco={
                              setRevelarSelectTipoEndereco
                            }
                            setCdTipoEndereco={setCdTipoEndereco}
                            styleClass="campo-select-novo-2"
                            setDsTipoEndereco={setDsTipoEndereco}
                            dsTipoEndereco={dsTipoEndereco}
                            phTipoEndereco={dsTipoEndereco}
                            setDsCep={setDsCep}
                            setDsEndereco={setDsEndereco}
                            setDsNumero={setDsNumero}
                            setDsBairro={setDsBairro}
                            setDsCidade={setDsCidade}
                            setDsEstado={setDsEstado}
                            setInfoAdicionais={setInfoAdicionais}
                            setCdEstado={setCdEstado}
                            setDsNomeFantasia={setDsNomeFantasia}
                            dsNomeFantasia={dsNomeFantasia}
                            cd_pav_cliente={props.cd_pav_cliente}
                          />
                        )}
                      </Form.Group>
                    </div>
                  </div>
                </Col>
              </Form.Row>
              {(cdTipoEndereco !== -1 || blAdicionarEndereco === true) && (
                <>
                  <Divider />
                  <Form.Row>
                    <Col>
                      <div className="grupo-painel-pedidos-novo-simcard-1">
                        <div className="coluna-painel-pedidos-novo-simcard-10">
                          <Form.Group>
                            <Form.Label>
                              <div className="fonte-cor-1 label-campo">CEP</div>
                            </Form.Label>
                            <Form.Control
                              name="ds_cep"
                              value={dsCep}
                              className="campo-texto-cor-3 campo-texto-novo-2"
                              type="text"
                              placeholder="Digite o cep"
                              onChange={(e) => setDsCep(e.target.value)}
                              ref={register({ required: true, min: 3, max: 9 })}
                              onBlur={(e) =>
                                handlerConsultarCep(e.target.value)
                              }
                              maxlength="9"
                              disabled={blAdicionarEndereco ? false : true}
                            />
                            {dsCepValidador && (
                              <p className="fonte-cor-3 label-alerta">
                                {iconeAlerta}{' '}
                                {dsCepValidador
                                  ? dsCepErroInfo
                                  : 'O campo é obrigatorio.'}
                              </p>
                            )}
                          </Form.Group>
                        </div>
                        <div className="coluna-painel-pedidos-novo-simcard-11">
                          <Form.Group>
                            <Form.Label>
                              <div className="fonte-cor-1 label-campo">
                                Endereço
                              </div>
                            </Form.Label>
                            <Form.Control
                              name="ds_endereco"
                              value={dsEndereco}
                              className="campo-texto-cor-3 campo-texto-novo-2"
                              type="text"
                              placeholder="Digite o nome da rua"
                              onChange={(e) => setDsEndereco(e.target.value)}
                              ref={register({
                                required: true,
                                min: 3,
                                max: 100
                              })}
                              maxlength="100"
                              disabled={
                                blAdicionarEndereco == true ? false : true
                              }
                            />
                            {dsEndereco === '' && <AvisoCampoObrigatorio />}
                          </Form.Group>
                        </div>
                        <div className="coluna-painel-pedidos-novo-simcard-12">
                          <Form.Group>
                            <Form.Label>
                              <div className="fonte-cor-1 label-campo">
                                Número
                              </div>
                            </Form.Label>
                            <Form.Control
                              name="ds_numero"
                              value={dsNumero}
                              className="campo-texto-cor-3 campo-texto-novo-2"
                              type="text"
                              placeholder="Digite o nº"
                              onChange={(e) => setDsNumero(e.target.value)}
                              ref={register({
                                required: true,
                                min: 3,
                                max: 100
                              })}
                              maxlength="4"
                              disabled={
                                blAdicionarEndereco == true ? false : true
                              }
                            />
                            {dsNumero === '' && <AvisoCampoObrigatorio />}
                          </Form.Group>
                        </div>
                      </div>
                    </Col>
                  </Form.Row>
                  <Form.Row>
                    <Col>
                      <div className="grupo-painel-pedidos-novo-simcard-1">
                        <div className="coluna-painel-pedidos-novo-simcard-10">
                          <Form.Group>
                            <Form.Label>
                              <div className="fonte-cor-1 label-campo">
                                Bairro
                              </div>
                            </Form.Label>
                            <Form.Control
                              name="ds_bairro"
                              value={dsBairro}
                              className="campo-texto-cor-3 campo-texto-novo-2"
                              type="text"
                              placeholder="Digite o bairro"
                              onChange={(e) => setDsBairro(e.target.value)}
                              ref={register({
                                required: true,
                                min: 3,
                                max: 100
                              })}
                              maxlength="100"
                              disabled={
                                blAdicionarEndereco == true ? false : true
                              }
                            />
                            {dsBairro === '' && <AvisoCampoObrigatorio />}
                          </Form.Group>
                        </div>
                        <div className="coluna-painel-pedidos-novo-simcard-11">
                          <Form.Group>
                            <Form.Label>
                              <div className="fonte-cor-1 label-campo">
                                Cidade
                              </div>
                            </Form.Label>
                            <Form.Control
                              /*disabled={errors.ds_cep || dsCepValidador || dsCep.length<=8?false:true}*/ name="ds_cidade"
                              value={dsCidade}
                              className="campo-texto-cor-3 campo-texto-novo-2"
                              type="text"
                              placeholder="Digite a cidade"
                              onChange={(e) => setDsCidade(e.target.value)}
                              ref={register({
                                required: true,
                                min: 3,
                                max: 100
                              })}
                              maxlength="100"
                              disabled={
                                blAdicionarEndereco == true ? false : true
                              }
                            />
                            {dsCidade === '' && <AvisoCampoObrigatorio />}
                          </Form.Group>
                        </div>
                        <div className="coluna-painel-pedidos-novo-simcard-12">
                          <Form.Group>
                            <Form.Label>
                              <div className="fonte-cor-1 label-campo">
                                Estado
                              </div>
                            </Form.Label>
                            {revelarSelectUf === false && (
                              <Button
                                disabled={
                                  blAdicionarEndereco == true ? false : true
                                }
                                name="cdUf"
                                className="campo-texto-cor-3 campo-select-novo"
                                onClick={() =>
                                  setRevelarSelectUf(!revelarSelectUf)
                                }
                              >
                                <div className="fonte-cor-1 label-campo">
                                  {dsEstado}
                                </div>
                                <img
                                  className="campo-select-icone-desativado"
                                  src={setaDropdown()}
                                  alt="drop"
                                />
                              </Button>
                            )}
                            {revelarSelectUf === true && (
                              <SelectUf
                                setRevelarSelectUf={setRevelarSelectUf}
                                styleClass="campo-select-novo"
                                setCdUf={setCdEstado}
                                setDsUf={setDsEstado}
                                dsUf={dsEstado}
                                phUf={dsEstado}
                              />
                            )}
                            {cdEstado == -1 && <AvisoCampoObrigatorio />}
                          </Form.Group>
                        </div>
                      </div>
                    </Col>
                  </Form.Row>
                  <Form.Row>
                    <Col>
                      <Form.Group>
                        <Form.Label>
                          <div className="fonte-cor-1 label-campo">
                            Informações adicionais (opcional)
                          </div>
                        </Form.Label>
                        <Form.Control
                          name="infoAdicionais"
                          value={infoAdicionais}
                          className="campo-texto-cor-3 campo-texto-novo-2"
                          type="text"
                          placeholder="Sala, apartamento, bloco, ponto de referência"
                          onChange={(e) => setInfoAdicionais(e.target.value)}
                          disabled={blAdicionarEndereco == true ? false : true}
                        />
                      </Form.Group>
                    </Col>
                  </Form.Row>
                </>
              )}
              <BotoesDadosEnvio
                {...{
                  mostrarBotaoAdicionarEndereco,
                  mostrarBotacaoCancelarAdicionarEndereco,
                  handleBlAdicionarEndereco
                }}
              />
            </>
          )}
        </div>

        {stepActive == 0 && (
          <>
            <Form.Row className="label-termos-cancelamento-reposicao-2 label-normal-caso">
              <Col>
                <span>
                  <span className="fonte-cor-1 label-alerta-reposicao">
                    *Este processo consiste em cancelar a linha atual e enviar
                    uma nova. Haverá o custo de taxa de R$5,00 por linha somente
                    se ela estiver sido adquirida a menos de 6 meses, caso
                    contrário, não pagará taxas. O prazo para conclusão desta
                    substituição é de 1 dia útil a partir da solicitação.
                  </span>
                </span>
              </Col>
            </Form.Row>
            <Form.Row className="label-termos-cancelamento-reposicao-2 label-normal-caso">
              <Col>
                <span>
                  <span className="fonte-cor-1 label-alerta-reposicao">
                    {' '}
                    *A reposição irá com o prazo de acordo com o contratado.
                  </span>
                </span>
              </Col>
            </Form.Row>
          </>
        )}

        <div className="modal-footer-novo-pedido">
          <Form.Row>
            <Col>
              <div className="resumo-pedido-linha-disclaimer">
                <span className="fonte-cor-1 label-normal contador-linhas-acoes-dispositivos">
                  {parsePedidosAdicionados().length} pedido(s) adicionado(s)
                </span>
                <span className="fonte-cor-1 label-normal contador-linhas-acoes-dispositivos">
                  {parseTotalLinhas()} linha(s) adicionada(s) aos pedidos
                </span>
                <span className="fonte-cor-1 label-normal contador-linhas-acoes-dispositivos">
                  O valor total de queima é de: R${somatorio},00
                </span>
                {quantidadeLinhasSelecionadas > parseTotalLinhas() && (
                  <>
                    <span className="fonte-cor-1 label-normal contador-linhas-acoes-dispositivos">
                      Você precisa adicionar{' '}
                      {quantidadeLinhasSelecionadas - parseTotalLinhas()}{' '}
                      linha(s) ao pedido de reposição
                    </span>
                  </>
                )}
              </div>
            </Col>
          </Form.Row>
          {((dsMotivo != 'Selecione' || dsMotivo != '') && stepActive === 0) ||
          (stepActive > 0 && parsePedidosAdicionados().length > 0) ? (
            <Form.Row>
              <Col>
                <Button
                  onClick={() => handleNextStep()}
                  className="botao-confirmar"
                  variant="success"
                  size="sm"
                >
                  <div className="fonte-cor-4">
                    {stepActive == 2 ? 'Confirmar' : 'Próximo'}
                  </div>
                </Button>
                <Button
                  className="botao-cancelar"
                  variant="success"
                  size="sm"
                  onClick={() => handlePreviousStep()}
                >
                  <div className="fonte-cor-2">
                    {stepActive == 0 ? 'Cancelar' : 'Voltar'}
                  </div>
                </Button>
              </Col>
            </Form.Row>
          ) : (
            <Form.Row>
              <Col>
                <OverlayTrigger
                  delay={{ show: 500, hide: 250 }}
                  placement="bottom"
                  overlay={
                    <Tooltip id="tooltip-bottom">
                      Finalize o detalhamento do pedido para avançar.
                    </Tooltip>
                  }
                >
                  <Button
                    className="botao-confirmar-desabilitado"
                    variant="success"
                    size="sm"
                  >
                    <div className="fonte-cor-4">
                      {stepActive == 2 ? 'Confirmar' : 'Próximo'}
                    </div>
                  </Button>
                </OverlayTrigger>
                <Button
                  className="botao-cancelar"
                  variant="success"
                  size="sm"
                  onClick={() => handlePreviousStep()}
                >
                  <div className="fonte-cor-2">
                    {stepActive == 0 ? 'Cancelar' : 'Voltar'}
                  </div>
                </Button>
              </Col>
            </Form.Row>
          )}
        </div>
      </div>

      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="Sua solicitação está em andamento,"
              mensagemParagrafo2="a confirmação de conclusão será enviada por e-mail em breve."
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
      {revelarMensagemAtencao && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemAtencao
              handleMensagemAtencao={handleMensagemAtencao}
              mensagemTitulo="Remover linha?"
              mensagemBotao="Remover"
            />
          </div>
        </div>
      )}
      {revelarMensagemAtencaoValor && (
        <MensagemAtencao
          handleMensagemAtencao={handleMensagemAtencaoValor}
          mensagemTitulo="Atenção:"
          mensagemParagrafo1={
            'O custo total da taxa será de R$' + somatorio + ',00'
          }
          mensagemBotao="Confirmar"
        />
      )}
      {revelarMensagemErroQuantidade && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              centralizarBotao
              handleMensagemErro={handleMensagemErroQuantidade}
              mensagemTitulo="Atenção:"
              mensagemParagrafo1="A quantidade de linhas informada é maior que a quantidade selecionada."
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}

      {revelarMensagemErroQuantidadeMenor && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              centralizarBotao
              handleMensagemErro={handleMensagemErroQuantidadeMenor}
              mensagemTitulo="Atenção:"
              mensagemParagrafo1="A quantidade de linhas informada é menor que a quantidade selecionada."
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              centralizarBotao
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarMensagemAtencaoInvalido && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <div className="modal-mensagem-atencao-acoes-simcards fundo-cor-6">
              <div className="mensagem-container-icone">
                <img
                  className="mensagem-icone"
                  src={alertaAtencao()}
                  alt="sucesso"
                />
              </div>
              <div className="fonte-cor-1 label-janela">
                {itensInvalidos.length} linhas foram retiradas
              </div>
              <div className="container-tabela-modal-itens-nao-permitidos">
                <BootstrapTable
                  classes="tabela-transparente-modais"
                  keyField="ds_linha"
                  condensed
                  data={itensInvalidos}
                  columns={COLUNAS_ITENS_INVALIDOS}
                  noDataIndication={!spinAtivo && 'Nenhum item encontrado'}
                  bootstrap4
                />
              </div>
              <div className="mensagem-container-botao">
                <Button
                  className="mensagem-botao-cancelar"
                  variant="success"
                  size="sm"
                  onClick={() => handleFecharMensagemItensInvalidos()}
                >
                  <div className="fonte-cor-2">Cancelar</div>
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Form>
  )
}
